.workspaceLoadingAnimation {
    height: 12rem;
}

.globalLoaderRoot {
    height: 100%;
    width: 100%;
}
